import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import SelectFormItem from "components/Input/Select";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { CheckboxFormItem, InputNumberForm, TextBoxForm } from "components/Input";
import Divider from "components/Divider";
import "./Register.css";
import { FiArrowRight, FiArrowLeft } from "react-icons/fi";
import React from "react";
import { RegisterContext } from "..";
import TableUI from "components/TableUI";
import { BtnAdd, BtnDeleteTable, BtnEditTable, BtnSaveIcon, BtnCancelIcon } from "components/Button";
import { ColumnProps } from "components/TableUI/TableUI";
import { AiFillEdit } from "react-icons/ai";
import { DatePickerFromItem } from "components/Input/DatePicker";
import { List } from "linqts";
import { TWorkHistory, TrainingHistory } from "./RegisterClass";
import { undefinedOrNull } from "utilities/Function";
import { SwAlert } from "components/Alert";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
import moment from "moment";
const StepForm5 = () => {
  const { handleNext, handleBack, arrTWorkHistory, setarrTWorkHistory, arrTrainingHistory, setarrTrainingHistory } = React.useContext(RegisterContext);
  const [isNow, setisNow] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [nEditWorkID, setnEditWorkID] = React.useState(null);
  const [nTrainingID, setnTrainingID] = React.useState(null);
  const [open2, setOpen2] = React.useState(false);

  const [dStartDate, setdStartDate] = React.useState(new Date(1955, 1, 1));
  const [dEndDate, setdEndDate] = React.useState(new Date());

  const [dStartDate2, setdStartDate2] = React.useState(new Date(1955, 1, 1));
  const [dEndDate2, setdEndDate2] = React.useState(new Date());

  //#region  ประวัติการทำงาน
  const objSchema = yup.object().shape({
    sCompanyName: yupFormSchemas.string("ชื่อบริษัท", { required: true }),
    sPosition: yupFormSchemas.string("ตำแหน่ง", { required: true }),
    dStartDate: yupFormSchemas.string("วันที่เข้าทำงาน", { required: true }),
    dEndDate: yupFormSchemas.string("วันที่ทำงานสุดท้าย", { required: isNow ? false : true }),
    sBehavior: yupFormSchemas.string("ลักษณะการทำงาน", { required: true }),
    sReasonForLeaving: yupFormSchemas.string("สาเหตุที่ออก", { required: false }),
  });

  const form = useForm({
    resolver: yupResolver(objSchema),
    shouldUnregister: false,
    shouldFocusError: true,
    mode: "all",
  });

  const ColumnData: ColumnProps[] = [{
    id: "nNo",
    name: "ลำดับ",
    width: "5%",
  },
  {
    id: "sCompanyName",
    name: "ชื่อบริษัท",
    width: "20%",
    cellAlign: "left"
  },
  {
    id: "sPosition",
    name: "ตำแหน่ง",
    width: "10%",
    cellAlign: "left"
  },
  {
    id: "sRangeDate",
    name: "ระยะเวลา",
    width: "15%",
    cellAlign: "center"
  },
  {
    id: "sBehavior",
    name: "ลักษณะการทำงาน",
    width: "20%",
    cellAlign: "left"
  },
  {
    id: "sReasonForLeaving",
    name: "สาเหตุที่ออก",
    width: "20%",
    cellAlign: "left"
  },
  {
    id: "Action",
    name: "",
    width: "5%",
    renderCell: (item) => {
      return (
        <div style={{ display: "inline-flex", textAlign: "center" }}>
          <BtnEditTable onClick={() => { onEdit1(item) }} />
          <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDelete1(item) }} />
        </div>
      )
    }
  }]
  const handleClickOpen1 = () => {
    setOpen1(true);
  };
  const handleClose1 = (event: object, reason: string) => {
    if (reason != "backdropClick") {
      form.setValue("sCompanyName", null);
      form.setValue("sPosition", null);
      form.setValue("dStartDate", null);
      form.setValue("dEndDate", null);
      form.setValue("sBehavior", null);
      form.setValue("sReasonForLeaving", null);
      form.setValue("isNow", false);
      form.setValue("nSalary", null);
      setisNow(false);
      form.clearErrors();
      setnEditWorkID(null);
      setOpen1(false);
    }
  };
  const onSave1 = () => {
    if (nEditWorkID) {
      let qStudy = new List<TWorkHistory>(arrTWorkHistory || []).FirstOrDefault(w => w.nID == nEditWorkID);
      if (qStudy) {
        qStudy.isNow = form.getValues("isNow");
        qStudy.sCompanyName = undefinedOrNull(form.getValues("sCompanyName"), "string");
        qStudy.sPosition = undefinedOrNull(form.getValues("sPosition"), "string");
        qStudy.dStartDate = undefinedOrNull(form.getValues("dStartDate"), "dateToString");
        qStudy.dEndDate = undefinedOrNull(form.getValues("dEndDate"), "dateToString");
        qStudy.sBehavior = undefinedOrNull(form.getValues("sBehavior"), "string");
        qStudy.sReasonForLeaving = undefinedOrNull(form.getValues("sReasonForLeaving"), "string");
        qStudy.nSalary = undefinedOrNull(form.getValues("nSalary"), "number");
        qStudy.dStartDateData = form.getValues("dStartDate");
        qStudy.dEndDateData = form.getValues("dEndDate");
        qStudy.sRangeDate = (moment(qStudy.dStartDateData).format('MM') + "/" + (moment(qStudy.dStartDateData).year() + 543)) + " - " + (qStudy.isNow ? "ถึงปัจจุบัน" : moment(qStudy.dEndDateData).format('MM') + "/" + (moment(qStudy.dEndDateData).year() + 543));
      }
    } else {
      let lstarrStudy = new List<TWorkHistory>(arrTWorkHistory || []).ToList();
      let MaxID = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nID) + 1 : 1
      let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
      let data: TWorkHistory = {
        nID: MaxID,
        nNo: MaxNo,
        nOrderID: MaxNo,
        isNow: form.getValues("isNow"),
        sCompanyName: undefinedOrNull(form.getValues("sCompanyName"), "string"),
        sPosition: undefinedOrNull(form.getValues("sPosition"), "string"),
        dStartDate: undefinedOrNull(form.getValues("dStartDate"), "dateToString"),
        dEndDate: undefinedOrNull(form.getValues("dEndDate"), "dateToString"),
        sBehavior: undefinedOrNull(form.getValues("sBehavior"), "string"),
        sReasonForLeaving: undefinedOrNull(form.getValues("sReasonForLeaving"), "string"),
        nSalary: undefinedOrNull(form.getValues("nSalary"), "number"),
        dStartDateData: form.getValues("dStartDate"),
        dEndDateData: form.getValues("dEndDate"),
        sRangeDate: (moment(form.getValues("dStartDate")).format('MM') + "/" + (moment(form.getValues("dStartDate")).year() + 543)) + " - " + (form.getValues("isNow") ? "ถึงปัจจุบัน" : (moment(form.getValues("dEndDate")).format('MM') + "/" + (moment(form.getValues("dEndDate")).year() + 543)))

      }
      setarrTWorkHistory([...arrTWorkHistory, { ...data }])
    }
    handleClose1(null, "");
  };
  const onDelete1 = (obj: TWorkHistory) => {
    SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
      setarrTWorkHistory(new List<TWorkHistory>(arrTWorkHistory || []).Where(w => w.nID != obj.nID).ToArray())
    });
  }
  const onEdit1 = (obj: TWorkHistory) => {
    console.log("s", obj);

    setnEditWorkID(obj.nID);
    form.setValue("sCompanyName", undefinedOrNull(obj.sCompanyName, "string"));
    form.setValue("sPosition", undefinedOrNull(obj.sPosition, "string"));
    form.setValue("dStartDate", moment(obj.dStartDateData));
    form.setValue("dEndDate", moment(obj.dEndDateData));
    form.setValue("sBehavior", undefinedOrNull(obj.sBehavior, "string"));
    form.setValue("sReasonForLeaving", undefinedOrNull(obj.sReasonForLeaving, "string"));
    form.setValue("nSalary", undefinedOrNull(obj.nSalary, "string"));
    form.setValue("isNow", obj.isNow);
    setisNow(obj.isNow);
    handleClickOpen1();
  }
  //#endregion

  //#region  ประวัติการฝึกอบรม
  const ColumnData2: ColumnProps[] = [{
    id: "nNo",
    name: "ลำดับ",
    width: "5%",
  },
  {
    id: "sCourseName",
    name: "ชื่อหลักสูตรที่เข้ารับการอบรม",
    width: "20%",
    cellAlign: "left"
  },
  {
    id: "sCompanyName",
    name: "ซื่อบริษัท",
    width: "15%",
    cellAlign: "left"
  },
  {
    id: "sRangeDate",
    name: "ระยะเวลา",
    width: "10%",
    cellAlign: "center"
  },
  {
    id: "sNatureTraining",
    name: "ลักษณะการอบรม",
    width: "20%",
    cellAlign: "left"
  },
  {
    id: "Action",
    name: "",
    width: "5%",
    renderCell: (item) => {
      return (
        <div style={{ display: "inline-flex", textAlign: "center" }}>
          <BtnEditTable onClick={() => { onEdit2(item) }} />
          <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDelete2(item) }} />
        </div>
      )
    }
  }]
  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = (event: object, reason: string) => {
    if (reason != "backdropClick") {
      form2.setValue("sCourseName", null);
      form2.setValue("sCompanyName", null);
      form2.setValue("dStartDate", null);
      form2.setValue("dEndDate", null);
      form2.setValue("sNatureTraining", null);
      form2.clearErrors();
      setnTrainingID(null);
      setOpen2(false);
    }
  };
  const objSchema2 = yup.object().shape({
    sCourseName: yupFormSchemas.string("ชื่อหลักสูตร", { required: true }),
    sCompanyName: yupFormSchemas.string("ชื่อบริษัท", { required: true }),
    dStartDate: yupFormSchemas.string("วันที่เริ่ม", { required: true }),
    dEndDate: yupFormSchemas.string("วันที่จบ", { required: true }),
    sNatureTraining: yupFormSchemas.string("ลักษณะการอบรม", { required: true }),
  });

  const form2 = useForm({
    resolver: yupResolver(objSchema2),
    shouldUnregister: false,
    shouldFocusError: true,
    mode: "all",
  });
  const onSave2 = () => {
    if (nTrainingID) {
      let qStudy = new List<TrainingHistory>(arrTrainingHistory || []).FirstOrDefault(w => w.nID == nTrainingID);
      if (qStudy) {

        qStudy.sCompanyName = undefinedOrNull(form2.getValues("sCompanyName"), "string");
        qStudy.dStartDate = undefinedOrNull(form2.getValues("dStartDate"), "dateToString");
        qStudy.dEndDate = isNow ? null : undefinedOrNull(form2.getValues("dEndDate"), "dateToString");
        qStudy.sCourseName = undefinedOrNull(form2.getValues("sCourseName"), "string");
        qStudy.sNatureTraining = undefinedOrNull(form2.getValues("sNatureTraining"), "string");
        qStudy.dStartDateData = form2.getValues("dStartDate");
        qStudy.dEndDateData = form2.getValues("dEndDate");
        qStudy.sRangeDate = qStudy.sRangeDate = (moment(qStudy.dStartDateData).format('MM') + "/" + (moment(qStudy.dStartDateData).year() + 543)) + " - " + moment(qStudy.dEndDateData).format('MM') + "/" + (moment(qStudy.dEndDateData).year() + 543);
      }
    } else {
      let lstarrStudy = new List<TrainingHistory>(arrTrainingHistory || []).ToList();
      let MaxID = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nID) + 1 : 1
      let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
      let data: TrainingHistory = {
        nID: MaxID,
        nNo: MaxNo,
        nOrderID: MaxNo,
        sCompanyName: undefinedOrNull(form2.getValues("sCompanyName"), "string"),
        sCourseName: undefinedOrNull(form2.getValues("sCourseName"), "string"),
        dStartDate: undefinedOrNull(form2.getValues("dStartDate"), "dateToString"),
        dEndDate: undefinedOrNull(form2.getValues("dEndDate"), "dateToString"),
        sNatureTraining: undefinedOrNull(form2.getValues("sNatureTraining"), "string"),
        dStartDateData: form2.getValues("dStartDate"),
        dEndDateData: form2.getValues("dEndDate"),
        sRangeDate: (moment(form2.getValues("dStartDate")).format('MM') + "/" + (moment(form2.getValues("dStartDate")).year() + 543)) + " - " + (moment(form2.getValues("dEndDate")).format('MM') + "/" + (moment(form2.getValues("dEndDate")).year() + 543))

      }
      setarrTrainingHistory([...arrTrainingHistory, { ...data }])
    }
    handleClose2(null, "");
  };
  const onDelete2 = (obj: TrainingHistory) => {
    SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
      setarrTrainingHistory(new List<TWorkHistory>(arrTrainingHistory || []).Where(w => w.nID != obj.nID).ToArray())
    });
  }
  const onEdit2 = (obj: TrainingHistory) => {
    setnTrainingID(obj.nID);
    form2.setValue("sCompanyName", undefinedOrNull(obj.sCompanyName, "string"));
    form2.setValue("sCourseName", undefinedOrNull(obj.sCourseName, "string"));
    form2.setValue("dStartDate", undefinedOrNull(obj.dStartDate, "string"));
    form2.setValue("dEndDate", undefinedOrNull(obj.dEndDate, "string"));
    form2.setValue("sNatureTraining", undefinedOrNull(obj.sNatureTraining, "string"));
    form2.setValue("dStartDate", moment(obj.dStartDateData));
    form2.setValue("dEndDate", moment(obj.dEndDateData));
    handleClickOpen2();
  }
  //#endregion
  return (
    <>
      <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1}>
        <Grid item md={12} xs={12}>
          <Divider><div style={{ display: "flex" }}><p>ประวัติการทำงาน</p></div></Divider>
        </Grid>
        <Grid item md={12} xs={12}>
          <TableUI column={ColumnData || []}
            row={arrTWorkHistory || []} />
        </Grid>
        <Grid item md={12} xs={12}>
          <BtnAdd onClick={handleClickOpen1} />
        </Grid>


        <Grid item md={12} xs={12}>
          <Divider>ประวัติการฝึกอบรม</Divider>
        </Grid>
        <Grid item md={12} xs={12}>
          <TableUI column={ColumnData2 || []}
            row={arrTrainingHistory || []} />
        </Grid>
        <Grid item md={12} xs={12}>
          <BtnAdd onClick={handleClickOpen2} />
        </Grid>

        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="start" justifyContent="start" sx={{}}>
            <button className="buttonBack" onClick={handleBack}>
              <FiArrowLeft />
              <span>กลับ</span>
            </button>
          </Grid>
        </Grid>
        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="end" justifyContent="end" sx={{}}>
            <button className="buttonNext" onClick={handleNext}>
              <span>ต่อไป</span>
              <FiArrowRight />
            </button>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={open1}
        onClose={handleClose1}
        sx={{ borderRadius: "23px" }}
      >
        <DialogTitle style={{
          borderBottom: "1px solid #FD8D14"
        }}><AiFillEdit /> ประวัติการทำงาน</DialogTitle>
        <DialogContent>
          <FormProvider {...form}>
            <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
              <Grid item md={6} xs={12}>
                <TextBoxForm name={"sCompanyName"} label={"ชื่อบริษัท"} required maxLength={250} />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextBoxForm name={"sPosition"} label={"ตำแหน่ง"} required maxLength={250} />
              </Grid>
              <Grid item md={2} xs={12}>
                <InputNumberForm name={"nSalary"} label={"เงินเดือน"} required maxDigits={2} />
              </Grid>
              <Grid item md={4} xs={12}>
                <DatePickerFromItem name={"dStartDate"} label={"วันที่เข้าทำงาน"} fullWidth
                  maxDate={dEndDate}
                  minDate={new Date(1955, 1, 1)} required
                  onChange={(e) => {
                    setdStartDate(e)
                  }}
                />
              </Grid>
              <Grid item md={1.5} xs={12}>
                <CheckboxFormItem name="isNow" label="ถึงปัจจุบัน" onChange={(e) => { setisNow(e) }} />
              </Grid>
              <Grid item md={4.5} xs={12}>
                {!isNow && <DatePickerFromItem name={"dEndDate"} label={"วันที่ทำงานสุดท้าย"} fullWidth
                  maxDate={Date()} required
                  minDate={dStartDate}
                  onChange={(e) => {
                    setdEndDate(e)
                  }}
                />}
              </Grid>

              <Grid item md={6} xs={12}>
                <TextBoxForm name={"sBehavior"} label={"ลักษณะการทำงาน"} multiline rows={4} required maxLength={1000} />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextBoxForm name={"sReasonForLeaving"} label={"สาเหตุที่ออก"} multiline rows={4} maxLength={1000} />
              </Grid>
            </Grid>
          </FormProvider>
          {/* </Box> */}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Close</Button> */}
          <BtnCancelIcon onClick={() => handleClose1({}, "")} />
          <BtnSaveIcon onClick={form.handleSubmit(() => { onSave1(); })} />
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={open2}
        onClose={handleClose2}
        sx={{ borderRadius: "23px" }}
      >
        <DialogTitle style={{
          borderBottom: "1px solid #FD8D14"
        }}><AiFillEdit /> ประวัติการฝึกอบรม</DialogTitle>
        <DialogContent>
          <FormProvider {...form2}>
            <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
              <Grid item md={6} xs={12}>
                <TextBoxForm name={"sCourseName"} label={"ชื่อหลักสูตร"} required maxLength={250} />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextBoxForm name={"sCompanyName"} label={"ชื่อบริษัท"} required maxLength={250} />
              </Grid>
              <Grid item md={6} xs={12}>
                <DatePickerFromItem name={"dStartDate"} label={"วันที่เริ่ม"} required fullWidth
                  maxDate={dEndDate2}
                  minDate={new Date(1955, 1, 1)}
                  onChange={(e) => {
                    setdStartDate2(e)
                    form2.setValue("dEndDate", null);
                  }}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <DatePickerFromItem name={"dEndDate"} label={"วันที่จบ"} required fullWidth
                  maxDate={new Date()}
                  minDate={dStartDate2}
                  onChange={(e) => {
                    setdEndDate2(e)
                  }}
                />
              </Grid>

              <Grid item md={12} xs={12}>
                <TextBoxForm name={"sNatureTraining"} label={"ลักษณะการอบรม"} multiline rows={4} required maxLength={1000} />
              </Grid>

            </Grid>
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <BtnCancelIcon onClick={() => handleClose2({}, "")} />
          <BtnSaveIcon onClick={form2.handleSubmit(() => { onSave2(); })} />
        </DialogActions>
      </Dialog>
    </>
  )
};

export default StepForm5;
